import React from 'react';
import InputRadioRender from './InputRadioRender';
import {InputProps} from '../../../interfaces';

export const InputRadio = ({...props}:InputProps):JSX.Element=>{
	return <InputRadioRender {...props}/>;
};
